import { BrandModel } from "./BrandModel";

export interface BannerModel {
    id?: string;
    cityOrState: string;
    deviceType: string;
    brand?: BrandModel;
    displayOnScreen: string;
    image: BannerImage;
}

export interface BannerImage {
    key: string,
    s3url: string
}